import { formatInTimeZone, utcToZonedTime } from "date-fns-tz";
import { enUS } from "date-fns/locale";

export const getRuntimeTimeZoneAndLocale = () => {
  const clientTimeZone = Intl.DateTimeFormat().resolvedOptions();
  return {
    timeZone: clientTimeZone.timeZone,
    locale: clientTimeZone.locale,
  };
};

export const convertUtcToLocal = (utcDateString) => {
  if (!utcDateString) return;
  const currentTimeZone = getRuntimeTimeZoneAndLocale();
  const utcString = utcDateString.endsWith("Z")
    ? utcDateString
    : `${utcDateString}Z`;

  return utcToZonedTime(utcString, currentTimeZone?.timeZone, {
    locale: currentTimeZone?.locale,
  });
};

export const formatInLocalTimeZone = (date, format) => {
  const currentTimeZone = getRuntimeTimeZoneAndLocale();
  return formatInTimeZone(date, currentTimeZone.timeZone, format, {
    locale: enUS, // date-fns-tz needs the import and not the local from the other function
  });
};

export const formatHumanReadableTime = (time) => {
  if (isNaN(time) || time <= 0) {
    return;
  }
  const hours = Math.floor(time / (1000 * 60 * 60));
  const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
  const hourText = hours > 0 ? `${hours} ${hours > 1 ? "hours" : "hour"}` : "";
  const minuteText =
    minutes > 0 ? `${minutes} ${minutes > 1 ? "minutes" : "minute"}` : "";
  const connector = hours > 0 && minutes > 0 ? " and " : "";

  return `${hourText}${connector}${minuteText}`;
};
